"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitConsentEvent = exports.tcfEventDataParser = exports.callWithSnowplowConsentStatus = void 0;
var core_api_1 = require("./core-api");
var SOURCEPOINT_SNOWPLOW_ID = '5eaaa739a55a2d743f32f7c3';
var callWithSnowplowConsentStatus = function (callback) {
    if (!!window.__tcfapi) {
        window.__tcfapi('getCustomVendorConsents', 2, function (vendorConsents) {
            callback(vendorConsents.grants[SOURCEPOINT_SNOWPLOW_ID].vendorGrant);
        });
    }
};
exports.callWithSnowplowConsentStatus = callWithSnowplowConsentStatus;
var visitorHasAcceptedAllPurposes = function (tcData) {
    var acceptedAllPurposes = false;
    if (tcData.purpose && tcData.purpose.consents && Object.keys(tcData.purpose.consents).length > 0) {
        acceptedAllPurposes = !Object.values(tcData.purpose.consents).includes(false);
    }
    return acceptedAllPurposes;
};
var tcfEventDataParser = function (tcData) {
    var acceptedAllPurposes = visitorHasAcceptedAllPurposes(tcData);
    if (tcData.eventStatus === 'useractioncomplete') {
        var consentEvent = {
            SCHEMA_KEY: 'Consent100',
            is_accept_all: acceptedAllPurposes,
            policy_version: String(tcData.tcfPolicyVersion),
        };
        (0, core_api_1.snowplowFireEvent)(consentEvent);
    }
};
exports.tcfEventDataParser = tcfEventDataParser;
var submitConsentEvent = function () {
    var _a;
    if (window.__tcfapi) {
        if (!((_a = window.AT_CONSENT) === null || _a === void 0 ? void 0 : _a.consentListenerAdded)) {
            window.__tcfapi('addEventListener', 2, exports.tcfEventDataParser);
            window.AT_CONSENT = __assign(__assign({}, window.AT_CONSENT), { consentListenerAdded: true });
        }
    }
};
exports.submitConsentEvent = submitConsentEvent;
